import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=b2084280&scoped=true&"
import script from "./Kpi.vue?vue&type=script&lang=js&"
export * from "./Kpi.vue?vue&type=script&lang=js&"
import style0 from "./Kpi.vue?vue&type=style&index=0&id=b2084280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2084280",
  null
  
)

export default component.exports